import { Input } from '@headlessui/react';
import clsx from 'clsx';
import { useRef } from 'react';

import { Button } from '@/shared';
import { useMount } from '@/shared/hooks';
import { XMarkIcon } from '@/shared/ui/icon';

import { usePaymentStore } from '../../../store';

export const PromoCodeInput = () => {
	const {
		values: formValues,
		errors,
		isPromoCodeValidating,
		updateValues,
		validatePromoCode,
	} = usePaymentStore();

	const hasAutoValidated = useRef(false);

	// Автоматическая валидация промокода из URL при маунте
	useMount(() => {
		if (
			formValues.promoCode &&
			!formValues.promoCodeValidated &&
			!hasAutoValidated.current &&
			!isPromoCodeValidating
		) {
			hasAutoValidated.current = true;
			validatePromoCode();
		}
	});

	const handlePromoCodeApply = async () => {
		await validatePromoCode();
	};

	const handlePromoCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		if (formValues.promoCodeValidated) {
			updateValues({
				promoCode: value,
				promoCodeValidated: false,
				promoCodeType: null,
			});
		} else {
			updateValues({ promoCode: value });
		}
	};

	const handlePromoCodeReset = () => {
		updateValues({
			promoCode: '',
			promoCodeValidated: false,
			promoCodeType: null,
		});
	};

	return (
		<div className="mb-6 mt-6">
			<label className="mb-2 block text-sm font-medium text-gray-3">
				Промокод
			</label>
			<div className="flex gap-2">
				<div className="flex-1">
					<Input
						value={formValues.promoCode}
						onChange={handlePromoCodeChange}
						placeholder="Введите промокод"
						disabled={formValues.promoCodeValidated || isPromoCodeValidating}
						className={clsx(
							'block w-full rounded-lg border px-4 py-3 text-sm outline-none transition-all disabled:cursor-not-allowed disabled:opacity-50',
							formValues.promoCodeValidated && 'border-green bg-green-50',
							errors?.promoCode && 'border-red-500',
							!formValues.promoCodeValidated &&
								!errors?.promoCode &&
								'border-gray-4 focus:border-accent',
						)}
					/>
					{errors?.promoCode && (
						<p className="mt-1 text-sm text-red-500">
							{errors.promoCode.join(', ')}
						</p>
					)}
				</div>
				{!formValues.promoCodeValidated && (
					<Button
						type="button"
						variant="outline"
						onClick={handlePromoCodeApply}
						loading={isPromoCodeValidating}
						disabled={!formValues.promoCode.trim() || isPromoCodeValidating}
						className="h-[46px]"
					>
						Применить
					</Button>
				)}
				{formValues.promoCodeValidated && (
					<Button
						type="button"
						onClick={handlePromoCodeReset}
						variant="outline"
						size="md"
						className="h-[44px]"
						aria-label="Сбросить промокод"
						title="Сбросить промокод"
					>
						<XMarkIcon className="size-5 text-gray-2" />
					</Button>
				)}
			</div>
		</div>
	);
};
